
import { Component, Prop, Watch } from 'vue-property-decorator'
import Publisher from '@/models/Publisher'
import ViewModel from '@/models/ViewModel'

@Component({})
export default class PublisherName extends ViewModel {
  @Prop({ default: '' })
  public id!: string;

  public name: string = 'N/A';

  public loading: boolean = true;

  public created() {
    this.update()
  }

  @Watch('id')
  public update() {
    this.loading = true
    if (this.id) {
      const o = Publisher.find(this.id)

      if (o) {
        this.name = o.name
        this.loading = false
      } else {
        Publisher.module
          .searchOptions({
            value: this.id,
          })
          .then((response : any) => {
            this.name = response[0].name
            this.loading = false
          })
      }
    } else {
      this.name = 'N/A'
      this.loading = false
    }
  }
}
